window.$ = window.jQuery = jQuery.noConflict(true);
